export default __webpack_public_path__ + "static/media/create-account.65fc7a6f.svg";